import axios from 'axios';

export default class VehicleService {

  static async getPrechecklistRecord(token, id){
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(`${url}/api/v1/pri/get-pre-check?id=${id}`, 
        {
          headers: {Authorization: `Bearer ${token}`},
        });
        return response
    } catch (error) {
      
      console.log(error)
    }
  }

  static async getImage(token, id){
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(`${url}/api/v1/pri/get-image?id=${id}`, 
        {
          headers: {Authorization: `Bearer ${token}`},
        });
        return response
    } catch (error) {
      
      console.log(error)
    }
  }

  static async getAllChecklist(token) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(
        `${url}/api/v1/pri/get-pre-checks`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  static async getVehicleCategories(token) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(
        `${url}/api/v1/pri/web/get-vehicle-categories`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  static async getVehicleTypesByCategory(token, category){

    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(`${url}/api/v1/pri/web/get-vehicle-types?category=${category}`, {
        headers: {Authorization: `Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}
